import React, {useRef, useState, useEffect} from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import StructuredText from "../custom-structured-text-renderer";
import FormComponent from "../../form";
import {CloseCircle, EdgeTop2} from "../../icons";

const RequestSample = ({title, richContent, form, productLanding, theme}) => {

    return (
        <section className={`sample ${theme || ''}${productLanding ? ' sample--product' : ''}`} id='sample'>
            { productLanding &&
              <div className='sample__edge'>
                <EdgeTop2 color='#F1F0E4'/>
              </div>
            }
            <div className='sample__inner'>
                <button className='sample__close' onClick={() => window.history.back()}>
                    <CloseCircle/>
                </button>
                <div className='sample__content'>
                    {title && !productLanding && <h1>{parse(title)}</h1>}
                    {title && productLanding && <h2>{parse(title)}</h2>}
                    {richContent && <div><StructuredText data={richContent}/></div>}
                </div>
                <div className='sample__form' data-lenis-prevent>
                    {form?.length > 0 && <FormComponent form={form[0].form}/>}
                </div>
            </div>
        </section>
    )
}

export default RequestSample

export const query = graphql`
fragment RequestSampleProps on DatoCmsRequestSample {
  ... on DatoCmsRequestSample {
    id
    title
    richContent {
      value
    }
    form {
      form {
        ...FormProps
      }
    }
    productLanding
  }
}
`